"use client";

import Link from "next/link";
import Image from "next/image";

export function Footer() {
  return (
    <footer className="py-12 bg-[#0a0a0f] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Column 1: About */}
          <div className="flex flex-col gap-4">
            <Link href="/" className="flex items-center gap-2 w-fit">
              <img src="/favicon.png" alt="MPUNIT" className="w-8 h-8" />
              <span className="text-xl font-bold text-white">MPUNIT</span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              SaaS-аналитика для селлеров Wildberries и Ozon.
              Управляйте бизнесом на маркетплейсах с помощью данных.
            </p>
            <a
              href="mailto:hello@mpunit.com"
              className="text-muted-foreground hover:text-white transition-colors duration-200 text-sm"
            >
              hello@mpunit.com
            </a>
            <a
              href="https://t.me/tg_mpunit"
              target="_blank"
              rel="noopener noreferrer"
              className="w-fit"
            >
              <Image
                src="/images/footer-telegram.png"
                alt="Telegram"
                width={32}
                height={32}
                className="opacity-70 hover:opacity-100 transition-opacity duration-200"
              />
            </a>
          </div>

          {/* Column 2: Address & Payment */}
          <div className="flex flex-col gap-4">
            <p className="text-muted-foreground text-sm leading-relaxed">
              614000, Пермский край, г.&nbsp;Пермь,
              <br />
              улица Ленина, д.&nbsp;9, офис&nbsp;502
            </p>
            <div className="flex items-center gap-3 flex-wrap">
              <Image src="/images/footer-юmoney.png" alt="ЮKassa" width={40} height={24} className="opacity-70" />
              <Image src="/images/footer-visa.png" alt="Visa" width={40} height={24} className="opacity-70" />
              <Image src="/images/footer-sbp.png" alt="СБП" width={40} height={24} className="opacity-70" />
              <Image src="/images/footer-sber.png" alt="Сбер" width={40} height={24} className="opacity-70" />
            </div>
            <p className="text-muted-foreground text-xs leading-relaxed">
              Безналичный расчёт для юридических лиц и ИП
            </p>
            <p className="text-muted-foreground text-xs leading-relaxed">
              ПО распространяется в виде интернет-сервиса, специализированная
              установка ПО на стороне пользователя не требуется
            </p>
          </div>

          {/* Column 3: Links */}
          <div className="flex flex-col gap-3">
            <span className="text-white text-sm font-semibold mb-1">Документы</span>
            <Link
              href="/license"
              className="text-muted-foreground hover:text-white transition-colors duration-200 text-sm"
            >
              Лицензионный договор
            </Link>
            <Link
              href="/privacy"
              className="text-muted-foreground hover:text-white transition-colors duration-200 text-sm"
            >
              Политика обработки ПД
            </Link>
            <Link
              href="/terms"
              className="text-muted-foreground hover:text-white transition-colors duration-200 text-sm"
            >
              Пользовательское соглашение
            </Link>
            <Link
              href="/cookies"
              className="text-muted-foreground hover:text-white transition-colors duration-200 text-sm"
            >
              Политика cookies
            </Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center pt-8 border-t border-white/5">
          <p className="text-muted-foreground text-sm">
            &copy; 2026 — ООО «МП-ЮНИТ»
          </p>
        </div>
      </div>
    </footer>
  );
}
